:root {
  --brand: #00446a;
  --brand-alt: #03324c;
  --primary: #1379c8;
  --secondary: #d3e9fd;
  --info: #316186;
  --info-alt: #e6f2fe;
  --text-dark: #0a2433;
  --dark: #4e575f;
  --border: #a8b2b8;
  --disabled: #dfe4e7;
  --emphasis: #f0f3f5;
  --white: #ffffff;
  --black: #000000;
}

.primary-button {
  background-color: #1379c8;
}

.secondary-button {
  background-color: #d3e9fd;
}

.bg-secondary-hover:hover {
  background-color: #d3e9fd;
}

.button-border {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  border: none !important;
}

.text-button-border {
  box-shadow: none !important;
  border-radius: 3px;
  border: none !important;
}

.button-hover:not([disabled]):hover,
div > .button-hover:not([disabled]):hover {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 2000px rgba(0, 0, 0, 0.06) !important;
}

.button-active:not([disabled]):active,
div > .button-active:not([disabled]):active {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 2000px rgba(0, 0, 0, 0.12) !important;
}

.text-button-active:not([disabled]):active,
div > .text-button-active:not([disabled]):active {
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.12) !important;
}

.primary-button-disabled:disabled,
div > .primary-button-disabled:disabled {
  background-color: #a8b2b8;
}

.secondary-button-disabled:disabled,
div > .secondary-button-disabled:disabled {
  background-color: #dfe4e7;
  color: #a8b2b8;
}

.text-button-disabled:disabled,
div > .text-button-disabled:disabled {
  background-color: white;
  color: #a8b2b8;
}

.loading-button > span {
  display: inline-block;
}

.loading-button > .button-text {
  color: currentColor;
  opacity: 0.4;
}

button > .uikit-icon > svg {
  fill: currentColor !important;
}

button > .uikit-icon:only-child {
  margin-right: 0 !important;
}
